const formatter = new Intl.NumberFormat("hu-HU", {
  style: "currency",
  currency: "HUF",
  maximumFractionDigits: 0,
});

export function formatPrice(amount) {
  return formatter.format(Math.round(Number(amount) || 0));
}
